/**
 * Slot Check Search analytics events (GA4 via lib/analytics). One place for the
 * event names so they stay consistent: slot_check_search_* (snake_case).
 */
import { trackEvent } from './analytics';

export const US_EVENTS = {
  searchSubmitted: 'slot_check_search_submit',
  suggestionTapped: 'slot_check_search_suggestion_tap',
  groupingChanged: 'slot_check_search_group_change',
  resultTapped: 'slot_check_search_result_tap',
  casinoEntered: 'slot_check_search_casino_enter',
  globeReturnTapped: 'slot_check_search_globe_tap',
  mapTapped: 'slot_check_search_map_tap',
} as const;

export const trackUsSearchSubmitted = (p: {
  searchTerm: string;
  queryType: string;
  egms: number;
  casinos: number;
  partial: boolean;
}) =>
  trackEvent(US_EVENTS.searchSubmitted, {
    search_term: p.searchTerm,
    query_type: p.queryType,
    result_egms: p.egms,
    result_casinos: p.casinos,
    partial: p.partial,
  });

export const trackUsSuggestionTapped = (p: { suggestionType: 'game' | 'manufacturer' | 'asset' | 'all'; searchTerm: string }) =>
  trackEvent(US_EVENTS.suggestionTapped, { suggestion_type: p.suggestionType, search_term: p.searchTerm });

export const trackUsGroupingChanged = (group: string) => trackEvent(US_EVENTS.groupingChanged, { grouping: group });

export const trackUsResultTapped = (p: { resultType: 'egm' | 'game'; casinoId: number; gameName: string; grouping: string }) =>
  trackEvent(US_EVENTS.resultTapped, {
    result_type: p.resultType,
    casino_id: p.casinoId,
    game_name: p.gameName,
    grouping: p.grouping,
  });

export const trackUsCasinoEntered = (p: { casinoId: number; gameName: string; egms: number; openedDetail: boolean }) =>
  trackEvent(US_EVENTS.casinoEntered, {
    casino_id: p.casinoId,
    game_name: p.gameName,
    result_egms: p.egms,
    opened_detail: p.openedDetail,
  });

export const trackUsGlobeTapped = (active: boolean) => trackEvent(US_EVENTS.globeReturnTapped, { search_active: active });

export const trackUsMapTapped = (p: { target: 'pin' | 'cluster'; casinoId?: number; clusterSize?: number }) =>
  trackEvent(US_EVENTS.mapTapped, { target: p.target, casino_id: p.casinoId, cluster_size: p.clusterSize });
